<div id="buyVoucherBase">
    <app-header [headerTitle]="'home.purchaseConfirmation' | translate" [navClose]="true" [showCredit]="true" [navBack]="'/voucher/'+ voucherId" [accessActions]="false">
    </app-header>

    <div *ngIf="!!toBuyVoucher" class="voucherInfo">
        <section class="inquerit baseContainer">
            <div class="voucher">
                <img [src]="toBuyVoucher.voucher.image_url" [alt]="toBuyVoucher.voucher.name">
                <p>{{ toBuyVoucher.voucher.name }}</p>
            </div>

            <button class="paymentMethod select view">
                <p [innerHTML]="toBuyVoucher.selected.game_coin_value + ' ' + toBuyVoucher.selected.game_coin_label"></p>
                <span class="userCoins" [innerHTML]="(toBuyVoucher.selected.ups_value | number:'1.0-0':'fr') +' <sup>'+ (global.propConfs$.coinSymbol || 'UP$') +'</sup>'"></span>
            </button>
        </section>
    </div>

    <div *ngIf="!!toBuyVoucher" class="baseContainer confirmPurchase">
        <h6>{{ 'home.isThisVoucher' | translate }}</h6>
        <button class="btn" (click)="doBuyVoucher()" [disabled]="loading_">{{ 'home.buyNow' | translate }}</button>
        <a *ngIf="!loading_" routerLink="/voucher/{{ voucherId }}">{{ 'home.chooseDifferentVoucher' | translate }}</a>
        <br><br>
        <a routerLink="/about/terms">{{ 'global.portal-terms' | translate }}</a>
    </div>
</div>